<template>
  <div>
    <wc-data-box
      v-if='estimate'
      :title='toolbarData.title'
      :titleIcon='toolbarData.icon'
      :titleIconColor='toolbarData.color'
      :showEdit='!editMode && !estimate.is_sold'
      @edit='edit'
    >
      <template v-slot:prependToolbarButtons>
        <v-slide-x-reverse-transition>
          <span v-if='editError' class='mr-4 caption red--text'> Please select a lot size category first </span>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition>
          <span v-if='editMode' class='caption grey--text'>
            {{ $vuetify.breakpoint.xs ? "Edit Mode" : "You're in edit mode. Changes must be saved."}}
          </span>
        </v-slide-x-reverse-transition>
        <v-btn v-if='editMode' small icon class='error mx-4' @click='cancelEdit'><v-icon color='white'>mdi-close</v-icon></v-btn>
        <v-btn v-if='editMode' small icon class='green' @click='update'><v-icon color='white'>mdi-check</v-icon></v-btn>
      </template>
      <v-simple-table v-if='$vuetify.breakpoint.smAndUp'>
        <thead>
          <tr>
            <th class="overline text-left">
              <span class='ml-6'>Services</span>
            </th>
            <th class="overline text-right">
            </th>
            <th></th>
        <th class="overline text-right">
              Totals
            </th>
          </tr>
        </thead>
      </v-simple-table>
      <v-card elevation='0'>
        <v-card-subtitle class='d-flex px-2 py-0'>
          <v-checkbox
            :readonly='!editMode'
            :color=" editMode ? 'primary' : 'grey darken-1' "
            :on-icon=" editMode ? '$checkboxOn' : 'mdi-check' "
            :off-icon=" editMode ? '$checkboxOff' : '' "
            :ripple="editMode"
            v-model='detailCopy.spring_cleanup'
            @change='springCleaupChange'
            label='Spring Cleanup'
            :hint="springCleanupHint"
            :persistent-hint='detailCopy.spring_cleanup'
          ></v-checkbox>
          <v-spacer></v-spacer>
          <span class='mr-2 mt-5 body-1 align-end'>{{ calcSpringCleanupPrice | decMoney }}</span>
        </v-card-subtitle>
        <v-expand-transition>
          <div v-show="detailCopy.spring_cleanup">
            <v-card-text class='d-flex caption' :class="$vuetify.breakpoint.xs ? 'flex-column' : '' ">
              <v-checkbox
                dense
                :class="$vuetify.breakpoint.xs ? 'mt-0' : 'ml-7 mt-n4 mb-n3'"
                :readonly='!editMode'
                :color=" editMode ? 'primary' : 'grey darken-1' "
                :on-icon=" editMode ? '$checkboxOn' : 'mdi-check' "
                :off-icon=" editMode ? '$checkboxOff' : '' "
                :ripple="editMode"
                v-model='detailCopy.aeration'
                label='Aeration'
                hint='discount not automatic'
                :persistent-hint='!detailCopy.aeration'
              ></v-checkbox>
              <v-checkbox
                dense
                :class="$vuetify.breakpoint.xs ? 'mt-0' : 'ml-7 mt-n4 mb-n3'"
                :readonly='!editMode'
                :color=" editMode ? 'primary' : 'grey darken-1' "
                :on-icon=" editMode ? '$checkboxOn' : 'mdi-check' "
                :off-icon=" editMode ? '$checkboxOff' : '' "
                :ripple="editMode"
                v-model='detailCopy.power_raking'
                label='Power Raking'
              ></v-checkbox>
              <v-checkbox
                dense
                :class="$vuetify.breakpoint.xs ? 'mt-0' : 'ml-7 mt-n4 mb-n3'"
                :readonly='!editMode'
                :color=" editMode ? 'primary' : 'grey darken-1' "
                :on-icon=" editMode ? '$checkboxOn' : 'mdi-check' "
                :off-icon=" editMode ? '$checkboxOff' : '' "
                :ripple="editMode"
                v-model='detailCopy.mowing'
                label='Mowing'
              ></v-checkbox>
              <v-checkbox
                dense
                :class="$vuetify.breakpoint.xs ? 'mt-0' : 'ml-7 mt-n4 mb-n3'"
                :readonly='!editMode'
                :color=" editMode ? 'primary' : 'grey darken-1' "
                :on-icon=" editMode ? '$checkboxOn' : 'mdi-check' "
                :off-icon=" editMode ? '$checkboxOff' : '' "
                :ripple="editMode"
                v-model='detailCopy.trimming'
                label='Trimming'
              ></v-checkbox>
              <v-checkbox
                dense
                :class="$vuetify.breakpoint.xs ? 'mt-0' : 'ml-7 mt-n4 mb-n3'"
                :readonly='!editMode'
                :color=" editMode ? 'primary' : 'grey darken-1' "
                :on-icon=" editMode ? '$checkboxOn' : 'mdi-check' "
                :off-icon=" editMode ? '$checkboxOff' : '' "
                :ripple="editMode"
                v-model='detailCopy.edging'
                label='Edging'
              ></v-checkbox>
              <v-checkbox
                v-if='detailCopy.spring_cleanup'
                dense
                :class="$vuetify.breakpoint.xs ? 'mt-0' : 'ml-7 mt-n4 mb-n3'"
                :readonly='!editMode'
                :color=" editMode ? 'primary' : 'grey darken-1' "
                :on-icon=" editMode ? '$checkboxOn' : 'mdi-check' "
                :off-icon=" editMode ? '$checkboxOff' : '' "
                :ripple="editMode"
                v-model='detailCopy.priority_spring_cleanup'
                label='Priority Service'
                hint="$50 added"
                :persistent-hint='detailCopy.priority_spring_cleanup'
              ></v-checkbox>
              <v-spacer></v-spacer>
              <div width='200px'>
                <v-text-field
                  v-if='editMode && detailCopy.spring_cleanup'
                  dense
                  :class="$vuetify.breakpoint.xs ? 'mt-6' : 'mr-12 ml-12 mt-n4 mb-n3'"
                  v-model='detailCopy.spring_cleanup_fee'
                  :rules='[rules.decimal]'
                  label='Additional Fee / Discount?'
                  :hint='!detailCopy.aeration ? "discount for no aeration?" : "(use negative number for discount)"'
                  persistent-hint
                ></v-text-field>
                <div 
                  v-if="!editMode && detailCopy.spring_cleanup_fee"
                  class='v-input align-left grey--text text--darken-1'
                  :class="$vuetify.breakpoint.xs ? 'mt-6' : 'mt-n3'"
                  style='width: 235px;'
                >
                  {{ detailCopy.spring_cleanup_fee | decMoney }}{{ (detailCopy.spring_cleanup_fee > 0) ? ' extra fee' : ' discount' }}
                </div>
              </div>
            </v-card-text>
          </div>
        </v-expand-transition>

        <v-divider></v-divider>

        <v-card-subtitle class='d-flex px-2 py-0'>
          <v-checkbox
            :readonly='!editMode'
            :color=" editMode ? 'primary' : 'grey darken-1' "
            :on-icon=" editMode ? '$checkboxOn' : 'mdi-check' "
            :off-icon=" editMode ? '$checkboxOff' : '' "
            :ripple="editMode"
            v-model='detailCopy.lawn_care'
            label='Regular Lawn Care'
            @change='lawnCareChange'
            :hint="lawnCareHint"
            :persistent-hint='detailCopy.lawn_care'
          ></v-checkbox>
          <v-spacer></v-spacer>
          <span class='mr-2 mt-5 body-1 align-end'>{{ calcLawnCarePrice | decMoney }}</span>
        </v-card-subtitle>
        <v-expand-transition>
          <div v-show="detailCopy.lawn_care">
            <v-card-text class='d-flex caption' :class="$vuetify.breakpoint.xs ? 'flex-column' : '' ">
              <v-checkbox
                dense
                :class="$vuetify.breakpoint.xs ? 'mt-0' : 'ml-7 mt-n4 mb-n3'"
                :readonly='!editMode'
                :color=" editMode ? 'primary' : 'grey darken-1' "
                :on-icon=" editMode ? '$checkboxOn' : 'mdi-check' "
                :off-icon=" editMode ? '$checkboxOff' : '' "
                :ripple="editMode"
                v-model='detailCopy.bag_clippings'
                label='Bag Clippings'
              ></v-checkbox>
              <v-spacer></v-spacer>
              <div>
                <v-text-field
                  v-if='editMode && detailCopy.lawn_care'
                  dense
                  :class="$vuetify.breakpoint.xs ? 'mt-6' : 'mr-12 ml-12 mt-n4 mb-n3'"
                  v-model='detailCopy.lawn_care_fee'
                  :rules='[rules.decimal]'
                  label='Additional Fee / Discount?'
                  hint='(use negative number for discount)'
                  persistent-hint
                ></v-text-field>
                <div 
                  v-if="!editMode && detailCopy.lawn_care_fee"
                  class='v-input align-left grey--text text--darken-1'
                  :class="$vuetify.breakpoint.xs ? 'mt-6' : 'mt-n3'"
                  style='width: 235px;'
                >
                  {{ detailCopy.lawn_care_fee | decMoney }}{{ (detailCopy.lawn_care_fee > 0) ? ' extra fee' : ' discount' }}
                </div>
              </div>
            </v-card-text>
          </div>
        </v-expand-transition>

        <v-divider></v-divider>

         <v-card-subtitle class='d-flex px-2 py-0'>
          <v-checkbox
            :readonly='!editMode'
            :color=" editMode ? 'primary' : 'grey darken-1' "
            :on-icon=" editMode ? '$checkboxOn' : 'mdi-check' "
            :off-icon=" editMode ? '$checkboxOff' : '' "
            :ripple="editMode"
            v-model='detailCopy.fertilizer'
            label='Fertilizer/Weed Control'
            @change='fertilizerChange'
            :hint='fertilizerHint'
            :persistent-hint='detailCopy.fertilizer'
          ></v-checkbox>
          <span class='ml-4 mt-2 caption align-center'>{{ detailCopy.fertilizer ? '' : '' }}</span>
          <v-spacer></v-spacer>
          <span class='mr-2 mt-5 body-1 align-end'>{{ calcFertilizerPrice | decMoney }}</span>
        </v-card-subtitle>
        <v-expand-transition>
          <div v-show="detailCopy.fertilizer">
            <v-card-text class='d-flex caption' :class="$vuetify.breakpoint.xs ? 'flex-column' : '' ">
            <v-spacer></v-spacer>
              <div>
                <v-text-field
                  v-if='editMode && detailCopy.fertilizer'
                  dense
                  :class="$vuetify.breakpoint.xs ? 'mt-6' : 'mr-12 ml-12 mt-n4 mb-n3'"
                  v-model='detailCopy.fertilizer_fee'
                  :rules='[rules.decimal]'
                  label='Additional Fee / Discount?'
                  hint='(use negative number for discount)'
                  persistent-hint
                ></v-text-field>
                <div 
                  v-if="!editMode && detailCopy.fertilizer_fee"
                  class='v-input align-left grey--text text--darken-1'
                  :class="$vuetify.breakpoint.xs ? 'mt-6' : 'mt-n3'"
                  style='width: 235px;'
                >
                  {{ detailCopy.fertilizer_fee | decMoney }}{{ (detailCopy.fertilizer_fee > 0) ? ' extra fee' : ' discount' }}
                </div>
              </div>
            </v-card-text>
          </div>
        </v-expand-transition>

        <v-divider></v-divider>

        <v-card-subtitle class='d-flex px-2 py-0'>
          <v-checkbox
            :readonly='!editMode'
            :color=" editMode ? 'primary' : 'grey darken-1' "
            :on-icon=" editMode ? '$checkboxOn' : 'mdi-check' "
            :off-icon=" editMode ? '$checkboxOff' : '' "
            :ripple="editMode"
            class='noCursor'
            v-model='detailCopy.additional_work'
            label='Additional Work'
            hint='outside of spring cleanup / lawncare'
            :persistent-hint='detailCopy.additional_work'
          ></v-checkbox>
          <span class='ml-4 mt-2 caption align-center'>{{ detailCopy.additional_work ? '' : '' }}</span>
          <v-spacer></v-spacer>
          <span class='mr-2 mt-5 body-1 align-end'>{{ calcAdditionalWorkPrice | decMoney }}</span>
        </v-card-subtitle>
        <v-expand-transition>
          <div v-show="detailCopy.additional_work">
            <v-card-text class='d-flex caption' :class="$vuetify.breakpoint.xs ? 'flex-column' : '' ">
              <v-text-field
                v-if='editMode'
                clearable
                dense
                :class="$vuetify.breakpoint.xs ? '' : 'ml-7 mt-n4'"
                :readonly='!editMode'
                v-model='detailCopy.additional_work_description'
                hint='Description - (eg. hedge timming, tree pruning)'
                persistent-hint
              ></v-text-field>
              <span
                v-else
                style='letter-spacing: -0.1px !important;'
                class='ml-7 mt-n3 body-1 grey--text text--darken-1'
              >
                {{ detailCopy.additional_work_description }}
              </span>
              <div width='200px'>
                <v-text-field
                  v-if='editMode && detailCopy.additional_work'
                  dense
                  :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mr-12 ml-12 mt-n4'"
                  v-model='detailCopy.additional_work_price'
                  :rules='[rules.decimal]'
                  hint='Price'
                  persistent-hint
                ></v-text-field>
              </div>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
    </wc-data-box>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment'; 
import formRules from '@/mixins/formRules';
import settingsAPI from '@/modules/settings/api/settings';

export default {
  name: 'lawn-service-details',
  mixins: [formRules],
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    editMode: false,
    editError: false,
    ratings: [],
    detailCopy: {},
    items: [
      'Non-standard Beds',
      'Kids Toys',
      'Play Structure',
      'Pool',
      'Lots of Leaves',
      'Uncut Edging',
      'Difficult Access',
    ],
  }),
  mounted() {
    this.getRatings()
    this.setupData()
  },
  watch: {
    'estimate.estimate_detail.rating'() {
      this.detailCopy.spring_cleanup_price = this.rating.spring_cleanup_base_price
      this.detailCopy.lawn_care_price = this.rating.base_price
      this.detailCopy.fertilizer_price = this.rating.fertilizer_base_price
    }
  },
  computed: {
    toolbarData () {
      if (!this.$vuetify.breakpoint.xs) {
        return {
          title: 'Lawn Care Details',
          icon: 'mdi-grass',
          color: 'green'
        }
      } else {
        return {
          title: 'Details',
          icon: '',
          color: 'green'
        }
      }
    },
    rating () {
      return _.find(this.ratings, r => r.id === this.estimate.estimate_detail.rating)
    },
    calcSpringCleanupPrice(){
      if (!this.rating || !this.detailCopy.spring_cleanup) {
        return 0
      } else {
        return this.detailCopy.spring_cleanup_price + parseFloat(this.detailCopy.spring_cleanup_fee) + (this.detailCopy.priority_spring_cleanup ? 40 : 0)
      }
    },
    calcLawnCarePrice(){
      if (!this.rating || !this.detailCopy.lawn_care) {
        return 0
      } else {
        return (this.detailCopy.lawn_care_price + parseFloat(this.detailCopy.lawn_care_fee))
      }
    },
    calcFertilizerPrice(){
      if (!this.rating || !this.detailCopy.fertilizer) {
        return 0
      } else {
        return this.detailCopy.fertilizer_price + parseFloat(this.detailCopy.fertilizer_fee)
      }
    },
    calcAdditionalWorkPrice(){
      if (!this.rating || !this.detailCopy.additional_work) {
        return 0
      } else {
        return parseFloat(this.detailCopy.additional_work_price)
      }
    },
    recommendedQuote () {
      return this.calcSpringCleanupPrice + this.calcLawnCarePrice + this.calcFertilizerPrice + this.calcAdditionalWorkPrice
    },
    monthsOfService () {
      if (this.estimate.start_date && this.estimate.end_date) {
        let end = moment(this.estimate.end_date)
        let start = moment(this.estimate.start_date)
        let duration = moment.duration(end.diff(start))
        return duration.as('months').toFixed(0)
      }
      return 4
    },
    springCleanupHint () {
      if (this.detailCopy.spring_cleanup_price) {
        return '$' + this.detailCopy.spring_cleanup_price + ' base price'
      }
      return ''
    },
    lawnCareHint () {
      if (this.detailCopy.lawn_care_price) {
        return '$' + this.detailCopy.lawn_care_price + ' per month (for ' + this.monthsOfService + ' months)'
      }
      return ''
    },
    fertilizerHint () {
      if (this.detailCopy.fertilizer_price) {
        return '$' + this.detailCopy.fertilizer_price + ' base price'
      }
      return ''
    }
  },
  methods: {
    edit () {
      if (this.rating) {
        this.setupData()
        this.editMode = true
      } else {
        this.editError = true
        setTimeout(() => {
          this.editError = false
        }, 3000)
      }
    },
    cancelEdit () {
      this.editMode = false;
      this.setupData();
    },
    update () {
      this.$emit('updateDetail', this.detailCopy);
      this.editMode = false;
    },
    setupData() {
      this.detailCopy = _.cloneDeep(this.estimate.estimate_detail);
    },
    async getRatings () {
      this.ratings = await settingsAPI.getRatings()
    },
    springCleaupChange() {
      if (this.detailCopy.spring_cleanup) {
        this.detailCopy.spring_cleanup_price = this.rating.spring_cleanup_base_price
        this.detailCopy.aeration = true
        this.detailCopy.power_raking = true
        this.detailCopy.mowing = true
        this.detailCopy.edging = true
        this.detailCopy.trimming = true
      } else {
        this.detailCopy.spring_cleanup_price = 0
        this.detailCopy.spring_cleanup_fee = 0
        this.detailCopy.aeration = false
        this.detailCopy.power_raking = false
        this.detailCopy.mowing = false
        this.detailCopy.edging = false
        this.detailCopy.trimming = false
        this.detailCopy.priority_spring_cleanup = false
      }
    },
    lawnCareChange() {
      if (this.detailCopy.lawn_care) {
        this.detailCopy.lawn_care_price = this.rating.base_price
      } else {
        this.detailCopy.lawn_care_price = 0
        this.detailCopy.lawn_care_fee = 0
      }
    },
    fertilizerChange() {
      if (this.detailCopy.fertilizer) {
        this.detailCopy.fertilizer_price = this.rating.fertilizer_base_price
      } else {
        this.detailCopy.fertilizer_price = 0
        this.detailCopy.fertilizer_fee = 0
      }
    },
  }
}
</script>